import { Controller } from "stimulus"
import Cleave from 'cleave.js';
require('cleave.js/dist/addons/cleave-phone.br')

export default class extends Controller {

  static targets = [ "cookies", "formErrors", "provinces", "cities", "nav", "menuBars", "closeIconMenu" ]

  connect() {
    // Verify Cookie
    if (document.cookie.indexOf("accepted_cookies=") < 0) {
      this.cookiesTarget.classList.remove("is-display-none")
    }

    var url = location.href.split("/")
    if (url[3] == "" || url[3] == "politica-de-privacidade" || url[3] == "termos-de-uso" || url[3] == "#impact" || url[3] == "#solutions" || url[3] == "#contact") {
      this.resize()
    }
  }

  // Disable links
  preventDefault(event) {
    event.preventDefault()
  }

  printReport() {
    window.print()
  }

  // Function for change page informations
  recoverPassword() {
    document.getElementById("form").classList.remove("is-display-block")
    document.getElementById("passwordInstructions").classList.add("is-display-block")
  }

  // Success form
  onPostError(event) {
    this.formErrorsTarget.innerText = ""
    const [data, status, xhr] = event.detail
    for (var i = 0; i < JSON.parse(xhr.response).length; i++) {
      var error = JSON.parse(xhr.response)[i]
      var li = document.createElement("li")
      li.appendChild(document.createTextNode(error))
      this.formErrorsTarget.appendChild(li)
    }
  }

  // Errors form
  onPostSuccess(event) {
    this.formErrorsTarget.innerText = ""
    let [data, status, xhr] = event.detail
  }

  // Focus input in sessions
  focused(el) {
    el.target.parentElement.classList.add("is-input-active")
  }

  // Lost focus input in sessions
  lostFocus(el) {
    if(el.target.value.length == 0) {
      el.target.parentElement.classList.remove("is-input-active")
    }
  }

  // Show and hide mobile menu
  resize() {
    var url = location.href.split("/")
    if (url[3] == "" || url[3] == "politica-de-privacidade" || url[3] == "termos-de-uso" || url[3] == "#impact" || url[3] == "#solutions" || url[3] == "#contact") {
      if (document.body.clientWidth > 768) {
        this.menuBarsTarget.classList.add("is-display-none")
        this.closeIconMenuTarget.classList.add("is-display-none")
        this.navTarget.classList.remove("mobile")
        this.navTarget.classList.remove("is-display-none")
      } else {
        this.menuBarsTarget.classList.remove("is-display-none")
        this.closeIconMenuTarget.classList.remove("is-display-none")
        this.navTarget.classList.add("mobile")
        this.navTarget.classList.add("is-display-none")
      }
    }
  }

  // Function to open menu
  openMenu(event) {
    document.querySelector("nav.mobile").classList.remove("is-display-none")
  }

  // Function to close menu
  closeMenu(event) {
    document.querySelector("nav.mobile").classList.add("is-display-none")
  }

  // Open modal
  openModal(event) {
    event.target.parentNode.nextElementSibling.style.display = "block"
  }

  // Close modal in click close icon
  closeModal() {
    document.querySelector('.modal[style*="display: block"]').style.display = "none"
  }

  // Close modal in click out modal area
  closeModalWithClickOut(event) {
    var modal = document.querySelector('.modal[style*="display: block"]')
    if (event.target == modal) {
      modal.style.display = "none"
    }
  }

  // Function to call an click input
  triggeredInput(event) {
    event.target.parentNode.parentNode.querySelector("input[type='file']").click()
  }

  // Function to change image if button is clicked
  changeImage(event) {
    const file = event.target.files[0]
    const img = event.target.parentNode.querySelector(".picture")
    const reader = new FileReader()
    reader.readAsDataURL(file, "UTF-8")
    reader.onload = function(e) {
      img.src = e.target.result
      const icon = event.target.parentNode.querySelector(".icon-image")
      if (icon) {
        icon.classList.add("is-display-none")
      }
      img.classList.remove("is-display-none")
    }
    reader.onerror = function(e) {
      console.log(e)
    }
  }

  // Function to change text if button is clicked
  changeTextFile(event) {
    let file = event.target.files[0]
    let p = event.target.parentNode.querySelector(".text-file")
    let reader = new FileReader()
    reader.readAsDataURL(file, "UTF-8")
    reader.onload = function(e) {
      p.textContent = file.name
    }
    reader.onerror = function(e) {
      console.log(e.target.error)
    }
  }

  // Change country and return provinces
  changeCountry(event) {
    var provincesTarget = this.provincesTarget
    var citiesTarget = this.citiesTarget
    if (event.currentTarget.value == "") {
      provincesTarget.options.length = 1
      citiesTarget.options.length = 1
    } else {
      fetch("/provincias/" + event.currentTarget.value).then(
        function(response) {
          return response.json().then(function(json) {
            provincesTarget.options.length = 1
            citiesTarget.options.length = 1
            for (var i = 0; i < json.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json[i]["name"]))
              option.value = json[i]["_id"]["$oid"]
              provincesTarget.appendChild(option)
            }
          })
        }
      )
    }
  }

  // Change province and return cities
  changeProvince(event) {
    var citiesTarget = this.citiesTarget
    if (event.currentTarget.value == "") {
      citiesTarget.options.length = 1
    } else {
      fetch("/cidades/" + event.currentTarget.value).then(
        function(response) {
          return response.json().then(function(json) {
            citiesTarget.options.length = 1
            for (var i = 0; i < json.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json[i]["name"]))
              option.value = json[i]["_id"]["$oid"]
              citiesTarget.appendChild(option)
            }
          })
        }
      )
    }
  }

  // Change residue type and return collection units
  changeResidueType(event) {
    var collectionUnitsTarget = this.collectionUnitsTarget
    if (event.currentTarget.value == "") {
      collectionUnitsTarget.options.length = 1
    } else {
      fetch("/unidades-de-coleta/" + event.currentTarget.value).then(
        function(response) {
          console.log(response)
          return response.json().then(function(json) {
            collectionUnitsTarget.options.length = 1
            for (var i = 0; i < json.length; i++) {
              var option = document.createElement("option")
              option.appendChild(document.createTextNode(json[i]["name"]))
              option.value = json[i]["_id"]["$oid"]
              collectionUnitsTarget.appendChild(option)
            }
          })
        }
      )
    }
  }

  // Accept cookies
  acceptCookies() {
    document.cookie = "accepted_cookies=yes; max-age=315360000; path=/"
    this.cookiesTarget.classList.add("is-display-none")
  }
}
